module.exports = __webpack_public_path__ + "static/media/page404.87569e11.png";